import map from "assets/images/auth-map.png";
import { APP_ROUTES } from "const";
import { memo } from "react";
import { Link } from "react-router-dom";

interface IAuthPanelProps {
  children: React.ReactNode;
  imageSrc?: string;
  imageAlt?: string;
}

function AuthPanel({
  children,
  imageSrc = map,
  imageAlt = "Decorative map background",
}: IAuthPanelProps) {
  return (
    <div className="flex w-full flex-1 items-center justify-center px-4 py-6 sm:px-6 sm:py-8 lg:px-8 lg:py-10">
      <div className="flex w-full max-w-[1100px] flex-col overflow-hidden rounded-xl bg-white shadow-sm lg:flex-row lg:shadow-md">
        <div className="relative hidden flex-1 lg:flex">
          <img
            className="absolute inset-0 h-full w-full object-cover"
            src={imageSrc}
            alt={imageAlt}
          />
        </div>
        <div className="flex w-full flex-1 flex-col justify-center bg-white px-4 py-6 sm:min-w-[350px] sm:px-10 sm:py-8 lg:max-w-lg lg:py-10">
          <div className="flex w-full flex-col gap-5">
            <Link
              to={APP_ROUTES.ISSUES}
              aria-label="Go to WeAttitude issues"
              className="inline-flex w-fit items-center text-sm font-semibold text-gray-700 transition-colors hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-400 focus-visible:ring-offset-2 focus-visible:ring-offset-white"
            >
              &lt;- Back to issues page
            </Link>
            <div className="w-full max-w-sm lg:w-96">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(AuthPanel);
